import { useState } from "react";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Card } from "@/components/SettingsSections";
import { inputCls } from "@/components/Bits";
import { useFetch } from "@/lib/useFetch";
import { api, errMsg } from "@/lib/api";

export const CategoriasManager = () => {
  const { data, reload } = useFetch("/categorias-servico");
  const [nome, setNome] = useState("");
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/categorias-servico", { nome }); setNome(""); toast.success("Categoria criada"); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  const toggle = async (c) => {
    try { await api.put(`/categorias-servico/${c.categoria_id}`, { nome: c.nome, ativo: !c.ativo, comissao: c.comissao || 0 }); reload(); }
    catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Card title="Categorias de serviço" testId="settings-categorias">
      <form onSubmit={add} className="flex gap-2 mb-4">
        <input className={inputCls} placeholder="Nova categoria" value={nome} onChange={(e) => setNome(e.target.value)} required minLength={2} data-testid="categoria-nome-input" />
        <button className="h-14 w-14 shrink-0 rounded-xl bg-[#1E4D2B] text-white flex items-center justify-center hover:bg-[#163A20]" aria-label="Adicionar" data-testid="categoria-add-button"><Plus className="h-6 w-6" /></button>
      </form>
      <ul className="divide-y divide-[#E2DDD3] max-h-96 overflow-y-auto">
        {(data || []).map((c) => (
          <li key={c.categoria_id} className="flex items-center justify-between gap-3 min-h-[52px]" data-testid={`categoria-${c.categoria_id}`}>
            <span className={c.ativo ? "" : "text-[#5C6B66] line-through"}>{c.nome}</span>
            <Switch checked={c.ativo} onCheckedChange={() => toggle(c)} data-testid={`categoria-toggle-${c.categoria_id}`} />
          </li>
        ))}
      </ul>
    </Card>
  );
};
